<div fxLayout="column">
  <div *ngIf="buttonChoice" fxLayout="row" fxFlex="40" fxLayoutAlign="end center">
    <button mat-button [disabled]="! itemSelected" (click)="onChoice()"
      [matTooltip]="toolTipElement()">{{labelButton}}</button>
  </div>
  <div>
    <!-- template checkbox pères et enfants -->
    <ng-template #checkboxTemplate let-node="node">
      <mat-checkbox [checked]="isSelected(node)"
                    (change)="nodeSelectionToggle($event, node)"></mat-checkbox>
    </ng-template>
    <!-- template élement et chevrons pères et enfants -->
    <ng-template #elementTemplate let-node="node">
      <button mat-button (click)="onSelectNode(node)">
        <span [ngClass]="itemSelected === node ? 'node-strong' : 'node-light'">{{getFieldsItemToDisplay(node)}}</span>
      </button>
    </ng-template>
    <!-- tree lazy -->
    <mat-tree [dataSource]="dataSource" [treeControl]="treeCodesControl">
      <!--  enfants -->
      <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding>
        <button mat-icon-button disabled></button>
        <ng-container *ngIf="displayChecked">
          <ng-container *ngTemplateOutlet="checkboxTemplate; context: {'node': node}"></ng-container>
        </ng-container>
        <ng-container *ngTemplateOutlet="elementTemplate; context: {'node': node}"></ng-container>
      </mat-tree-node>
      <!-- père / mère -->
      <mat-tree-node *matTreeNodeDef="let node; when: canExpand" matTreeNodePadding>
        <button mat-icon-button
                [attr.aria-label]="'toggle ' + node.name" matTreeNodeToggle>
          <mat-icon class="mat-icon-rtl-mirror">
            {{treeCodesControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
          </mat-icon>
        </button>
        <ng-container *ngIf="displayChecked">
          <ng-container *ngTemplateOutlet="checkboxTemplate; context: {'node': node}"></ng-container>
        </ng-container>
        <ng-container *ngTemplateOutlet="elementTemplate; context: {'node': node}"></ng-container>
        <mat-progress-bar *ngIf="showLoading && node.isLoading"
                          mode="indeterminate"
                          class="example-tree-progress-bar"></mat-progress-bar>
      </mat-tree-node>
    </mat-tree>
  </div>
  <div *ngIf="buttonChoice" fxLayout="row" fxFlex="40" fxLayoutAlign="end center">
    <button mat-button [disabled]="! itemSelected" (click)="onChoice()"
            [matTooltip]="toolTipElement()">{{labelButton}}</button>
  </div>
</div>
